import { ListLoader, ItemLoader } from "@/loaders";

export default {
  list: new ListLoader("/address-book/", {
    setter: "addressBook/setItems",
  }),
  item: new ItemLoader("/address-book/", {
    setter: "addressBook/updateItem",
    remover: "addressBook/deleteItem",
  }),
};
